export interface iTiposRetencion {
  id: number,
  value: string
}

export const TiposDeRetencion: iTiposRetencion[] = [
  {
    id: 0,
    value: ''
  }, {
    //15%
    id: 1,
    value: 'Profesionales'
  }, {
    //19%
    id: 2,
    value: 'Alquiler de local'
  }, {
    id: 3,
    value: 'No fiscales'
  }, {
    //2%
    id: 4,
    value: 'Agricultores'
  }, {
    //1%
    id: 5,
    value: 'Módulos'
  }, {
    id: 6,
    value: 'Alquiler de negocio'
  }, {
    //7%
    id: 7,
    value: 'Profesionales reducida'
  }
];
